import { render, staticRenderFns } from "./alertAssistant_teacher.vue?vue&type=template&id=62e77a1a&scoped=true&"
import script from "./alertAssistant_teacher.vue?vue&type=script&lang=js&"
export * from "./alertAssistant_teacher.vue?vue&type=script&lang=js&"
import style0 from "./alertAssistant_teacher.vue?vue&type=style&index=0&id=62e77a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e77a1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VChip,VCol,VIcon,VRow})
